import { type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 body-small-semibold transition-colors focus:outline-none focus:ring-0 focus:ring-ring focus:ring-offset-0",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export type BadgeProps = HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof badgeVariants> & {
    isLoading?: boolean;
  };

function Badge({
  className,
  variant,
  isLoading = false,
  ...props
}: BadgeProps) {
  return (
    <div
      className={cnTwMerge(badgeVariants({ variant }), className, {
        "skeleton-box": isLoading,
      })}
      data-ph-unmask=""
      {...props}
    />
  );
}

export { Badge, badgeVariants };
